import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { FONTS_PERMISSIONS } from "@/app/nav";
import { FontLibrary } from "@/features/fonts/FontLibrary";
import { staffRoute } from "@/routes/staff";

export const fontsRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "fonts",
  beforeLoad: ({ context }) => requirePermissions(context.session, FONTS_PERMISSIONS),
  component: FontLibrary,
});
